<!--
Author: TangChen
Date: 2018-11-19
Desc: 检查账户信息，由index.js 配置引入
 -->
<template>
    <div :class="'view-check-acct view bg-white ' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <el-row v-if="activeId==='0105'" class="inv-identification">
            <div class="investor-tips">
                <div class="tit-warn">
                    <i class="el-alert__icon el-icon-warning is-big" />
                    <span class="tit-warn-text">
                        根据
                        <span>《证监会适当性管理办法规定》</span>
                    </span>
                </div>
                <p class="tit">
                    经营机构向普通投资者销售产品或者提供服务前，投资者需签订以下协议：
                </p>
                <div class="investor-info" v-html="agrCon.content" />
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="100px"
                    size="small"
                >
                    <el-row>
                        <el-col :span="14">
                            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                                <el-input v-model="ruleForm.pwd" type="password" :maxlength="20" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button v-on:click.once="$router.back()">
                    取消
                </el-button>
                <el-button type="primary" v-on:click="submitForm">
                    我已阅知风险，并同意准入
                </el-button>
            </div>
        </el-row>
        <change-pwd v-if="activeId==='0101'" :fn="true" v-on:fn-back="updateIndex" />
        <risk-ques v-if="activeId==='0201'" :fn="true" v-on:fn-back="updateIndex" />
        <org-info v-if="activeId==='0102'" :fn="true" v-on:fn-back="updateIndex" />
        <inv-info v-if="activeId==='0103'" :fn="true" v-on:fn-back="updateIndex" />
        <crs-info v-if="activeId==='0104'" :fn="true" v-on:fn-back="updateIndex" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navBar from "@/components/common/navBar.vue";
import riskQues from "@/components/acctInfo/riskQues.vue";
import orgInfo from "@/components/acctInfo/orgInfo.vue";
import invInfo from "@/components/acctInfo/invInfo.vue";
import changePwd from "@/components/acctInfo/changePwd.vue";
import crsInfo from "@/components/acctInfo/crsInfo.vue";
export default {
    name: "CheckAcct",
    components: {
        navBar,
        riskQues,
        orgInfo,
        invInfo,
        changePwd,
        crsInfo
    },
    mixins: [mixin],
    data() {
        return {
            check: [],
            navs: [],
            activeId: "",
            indexNum: -1,
            isPwdCheck: false,
            agrCon: {},
            ruleForm: {
                pwd: ""
            },
            rules: {
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        indexNum(val) {
            this.$set(this.navs, val, {
                val: this.navs[val].val,
                id: this.navs[val].id,
                active: true
            });
            this.activeId = this.navs[val].id;
            if (this.activeId === "0105") {
                this.getProtocol();
            }
        }
    },
    created() {
        this.isPwdCheck = this.$cache.getPwdCheck("P3");
        this.acctInfo = this.$cache.getUser();
        this.check = this.$util.acctStatus(
            this.acctInfo,
            this.$route.query.cate
        );
        this.check.forEach(item => {
            this.navs.push({ val: item.tit, id: item.id });
        });
        this.indexNum++;
        if (this.navs.length > 1) {
            this.navs[this.navs.length - 1].icon = "fa fa-check";
        }
    },
    methods: {
        submitForm() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.identification();
                } else {
                    return false;
                }
            });
        },
        // 准入
        identification() {
            const _this = this;
            this.$util
                .request(
                    "acct/sdx/sign",
                    { tradepwd: this.$util.enc(this.ruleForm.pwd) },
                    "POST"
                )
                .then(res => {
                    if (res.data) {
                        const info = _this.$cache.getUser();
                        info.isneedidentify = "0";
                        _this.$store.dispatch("setInfo", info).then(() => {
                            _this.$message({
                                type: "success",
                                message: "准入协议签订成功！",
                                onClose: function() {
                                    _this.updateIndex();
                                }
                            });
                        });
                    }
                });
        },
        updateIndex() {
            const _this = this;
            if (this.navs[this.indexNum + 1]) {
                this.indexNum++;
            } else {
                this.$message({
                    type: "success",
                    message: "用户信息已完善，3秒后返回首页",
                    onClose: function() {
                        _this.$router.push({ name: "home" });
                    }
                });
            }
        },
        getProtocol() {
            let _this = this;
            this.$util.getProtocol("allow").then(res => {
                if (res && res.length === 0) {
                    _this.$alert("基金公司未添加准入协议，请联系公司客服添加", "准入协议", {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: "关闭",
                        customClass: "info-check"
                    }).then(() => {
                        _this.$router.push("/home");
                        return false;
                    }).catch(() => {
                        return false;
                    });
                    return false;
                }
                _this.$util.request("common/protocol/content", res[0]).then(res => {
                    if (res.data) {
                        const con = res.data[0];
                        if (con) {
                            _this.agrCon = con;
                        }
                    }
                });
            });
        }
    }
};
</script>
<style lang="scss">
.view-check-acct {
    padding-bottom: 40px;
    .comp-nav-bar {
        margin: 10px;
    }
    .comp-date-picker {
        width: auto;
    }
    .certexpdate-box {
        padding: 20px 0;
        .el-col {
            .form-text {
                margin-bottom: 10px;
            }
        }
    }
    .inv-identification {
        padding: 10px 40px 10px;
        .tit-warn {
            line-height: 40px;
            i {
                margin-right: 8px;
                vertical-align: middle;
            }
            .tit-warn-text {
                vertical-align: middle;
                span {
                    font-size: 20px;
                    margin-left: 5px;
                }
            }
        }
        .dialog-footer {
            text-align: center;
        }
        .investor-info {
            margin: 5px 0 20px;
            border-radius: 4px;
            padding: 10px 17px;
            .tit {
                font-size: 16px;
                line-height: 36px;
            }
            .list {
                line-height: 24px;
            }
        }
    }
    .el-button + .el-button {
        margin-left: 30px;
    }
}
</style>
